import classes from './Loader.module.scss';
import { useThemeStyle } from '../../../hooks/hooks';

const Loader = () => {
  const LoaderClass = useThemeStyle(classes, 'Loader')
  return <div className={LoaderClass}></div>;
};

export default Loader;
